<template>
    <div
        class="container-content px-md-6 mx-auto d-flex flex-column bg-transparent w-100"
        :class="[
            {
                'max-container': !fluid && !maxClass
            },
            outerContainer ? 'px-4 pt-4' : 'px-0 py-0',
            maxClass
        ]"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
    defineProps({
        fluid: {
            type: Boolean,
            default: false
        },
        maxClass: {
            type: String as PropType<Nullable<string>>,
            default: null
        },
        outerContainer: {
            type: Boolean,
            default: false
        }
    });
</script>

<style lang="scss"></style>
